import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import AnswerButtonContainer from '../AnswerButton/AnswerButtonContainer';
import LetterGenerator from '../../utils/letterGeneratorUtil';

const responseGap = '{{response}}';
const responseRegExp = new RegExp(`(${responseGap})`, 'g');

const FillBlankQuestionView = ({
    measure,
    possibleResponses,
    stimulus,
    id,
    selectedIndex,
    onAnswerClick,
    isEnabled,
}) => {
    const lettersArray = LetterGenerator(possibleResponses.length);

    const [questionInput, setQuestionInput] = useState({ selectedText: '', inputSize: 0 });

    const getSelectedText = () =>
        possibleResponses[selectedIndex] ? possibleResponses[selectedIndex].text : '';

    const getInputSize = () =>
        possibleResponses.reduce((maxLength, response) => {
            const { text } = response;
            return text.length > maxLength ? text.length : maxLength;
        }, 0);

    useEffect(() => {
        const selectedText = getSelectedText();
        const inputSize = getInputSize();
        setQuestionInput({ selectedText, inputSize });
    }, [selectedIndex]);

    const getQuestion = () => {
        const { text } = stimulus;
        return text
            .split(responseRegExp)
            .map(snippet =>
                snippet === responseGap ? (
                    <input
                        key={id}
                        aria-label="fill in the blank"
                        type="text"
                        readOnly={true}
                        size={questionInput.inputSize + 1}
                        value={questionInput.selectedText}
                        className="fill-in-blank"
                    />
                ) : (
                    snippet
                ),
            );
    };

    const getAnswerClickCallback = index => () => onAnswerClick(index);

    return (
        <div>
            <div className="comprehension-question">
                <div className={`${measure}-header`}>
                    <div className="header-text">{getQuestion()}</div>
                </div>
            </div>
            <div className="comprehension-answers">
                <p>Fill in the blank.</p>

                <div className="vertical-answer-buttons">
                    {possibleResponses.map((response, index) => (
                        <AnswerButtonContainer
                            key={response.id}
                            index={index}
                            letter={lettersArray[index]}
                            text={response.text}
                            isSelected={index === selectedIndex}
                            onAnswerClick={getAnswerClickCallback(index)}
                            isEnabled={isEnabled}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

FillBlankQuestionView.propTypes = {
    measure: PropTypes.string,
    possibleResponses: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired,
        }),
    ).isRequired,
    stimulus: PropTypes.shape({
        text: PropTypes.string.isRequired,
    }).isRequired,
    id: PropTypes.string,
    selectedIndex: PropTypes.number,
    onAnswerClick: PropTypes.func,
    isEnabled: PropTypes.bool.isRequired,
};

FillBlankQuestionView.defaultProps = {
    id: '',
    measure: '',
    selectedIndex: undefined,
    onAnswerClick: () => {},
};

export { FillBlankQuestionView as default };
